module.exports = __webpack_public_path__ + "img/news-content-back.d5bbc947.png";